/**
 * Shared SavingStep Component
 *
 * Displays a loading state while bookings are being saved.
 * Used by AddForm, EditForm, and potentially other forms.
 */

import React from "react";
import classNames from "classnames";
import { Spinner } from "@/components/ui/feedback/Spinner";
import styles from "./formUtilities.module.css";

export interface SavingStepProps {
  /** Message to display while saving */
  message: string;
  /** Optional additional CSS class */
  className?: string;
  /** Test ID for the container */
  "data-testid"?: string;
  /** Test ID for the inner loading container */
  loadingTestId?: string;
}

export const SavingStep: React.FC<SavingStepProps> = ({
  message,
  className,
  "data-testid": testId,
  loadingTestId,
}) => {
  return (
    <div
      className={classNames(styles.container, className)}
      data-testid={testId}
    >
      <div className={styles.loadingContainer} data-testid={loadingTestId}>
        <Spinner size="lg" />
        <span className={styles.loadingText}>{message}</span>
      </div>
    </div>
  );
};

SavingStep.displayName = "SavingStep";

export default SavingStep;
